import styled, { css } from 'styled-components';

export const MapOuterContainer = styled.div`
  align-items: center;
  min-height: 100%;
  background-color: #f2f2f2;

`;

export const MapInnerContainer = styled.div`
  margin: 0 auto;
  max-width: 1920px;
  align-items: center;
  position: relative;
  min-height: 100%;
`;

export const MapTextContainer = styled.div`
  width: 40%;
  position: absolute;
  top: 25%;
  left: 10%;
  margin: 0 auto;
  padding: 0 120px;
  min-height: 100%;

  [class*='Headingstyle__Heading-sc'] {
    font-size: 56px;
    font-weight: bold !important;
  }

  p {
    font-size: 18px;
  }

  @media (max-width: 1670px) {
    padding: 0 100px;
    width: 50%;
    top: 25%;
  }

  @media (max-width: 1460px) {
    padding: 0 80px;
  }

  @media (max-width: 1380px) {
    padding: 0 60px;
    top: 20%;

    [class*='Headingstyle__Heading-sc'] {
      font-size: 48px;
      line-height: normal;
      font-weight: bold !important;
    }

    p {
      font-size: 16px;
    }
  }

  @media (max-width: 1194px) {
    [class*='Headingstyle__Heading-sc'] {
      font-size: 32px;
    }

    p {
      font-size: 16px;
    }
  }

  @media (max-width: 1060px) {
    [class*='Headingstyle__Heading-sc'] {
      font-size: 24px;
      padding-bottom: 0 !important;
      margin-bottom: 5px !important;
    }

    p {
      font-size: 14px;
    }
  }

  @media (max-width: 930px) {
    position: relative;
    display: inline-block;
    padding: 0;
    margin: 30px auto 0 auto;
    width: 80%;

    [class*='RichTextstyles__ParsedContentWrapper'] {
      text-align: center;
    }

    [class*='Headingstyle__Heading-sc'] {
      font-size: 32px;
      font-weight: bold !important;
      padding-bottom: 20px !important;
      line-height: 1.1;
    }

    p {
      font-size: 18px;
    }
  }
`;

export const MapDesktopImageContainer = styled.div`
  align-items: center;
  width: 100%;

  @media (max-width: 930px) {
    display: none;
  }
`;

export const MapTabletImageContainer = styled.div`
  align-items: center;
  height: 100%;
  width: 100%;
  padding-bottom: 30px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 931px) {
    display: none;
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

export const MapMobileImageContainer = styled.div`
  align-items: center;
  height: 100%;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 641px) {
    display: none;
  }
`;
